import React, { useRef, useState, useEffect } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import axios from "axios";
import { useHistory } from "react-router-dom";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import prod1video from "../../Images/prod1video.mp4";
import prod2video from "../../Images/prod2video.mp4";
import widImage from "../../Images/WidImage.png";
import BossSection from "../../Images/BossSection.png";
import BossSection2 from "../../Images/BossSection2.png";
import BossSection11 from "../../Images/BossSection11.png";
import BossSection22 from "../../Images/BossSection22.png";
import BossSection33 from "../../Images/BossSection33.png";
import BossSection44 from "../../Images/BossSection44.png";
import { MyDomain } from "../../App";

export default function FirstBlock() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const [AdTopSection, setAdTopSection] = useState([]); //in last of work set it false
  const [Loading, setLoading] = useState(false); //in last of work set it false

  useEffect(() => {
    setAdTopSection([]);
    setLoading(false);

    axios
      .post(`${MyDomain}AdTopSection/GetAdTopSectionMainSection`)
      .then((response) => {
        const filteredData =
          response.data.adTopSections?.filter((item) => item.itsRun === 1) ||
          [];

        setAdTopSection(filteredData);
        setLoading(true);
      })
      .catch((error) => {});
  }, []);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${MyDomain}News/GetAllNews`);
        setData(response.data);
      } catch (err) {
      } finally {
      }
    };

    fetchData();
  }, []);

  const carouselRef = useRef(null);
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [showArrows, setShowArrows] = useState(true); //in last of work set it false

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  const handleVideoEnd = () => {
    const video = videoRef.current;
    video.currentTime = 0;
    video.play();
  };

  const prevSlide = () => {
    carouselRef.current.prev();
  };

  const nextSlide = () => {
    carouselRef.current.next();
  };

  const handleMouseEnter = () => {
    setShowArrows(true);
  };

  const handleMouseLeave = () => {
    setShowArrows(false);
  };
  const GoTo = async (TheId, TheLink) => {
    if (TheLink.includes("allcategories")) {
      handleDivClick2(TheId, TheLink);
      return;
    } else {
      try {
        setLoading(false);
        axios
          .post(`${MyDomain}News/GetOneNews`, TheId, {
            headers: {
              "Content-Type": "application/json", // Ensure the server knows the payload type
            },
          })
          .then((response) => {
            setData(response.data);
            handleDivClick(response.data, TheId, TheLink);
          })
          .catch((err) => {
            console.log(err.response.data);
          });
      } catch (err) {
        //setError("Failed to fetch product data");
      } finally {
        setLoading(true);
      }
    }
  };
  // const handleDivClick = (CategoryName) => {
  //   //history.push(`/product/${ProductId}`);
  //   history.push(`${CategoryName}`);
  // };
  const handleDivClick = (TheObject, NameOfCategory, TheLink) => {
    history.push({
      pathname: `${TheLink}`,
      state: TheObject, // Pass CategoryName here
    });
    scrollToTop2();
  };
  const handleDivClick2 = (NameOfCategory, TheLink) => {
    history.push({
      pathname: `${TheLink}`,
    });
    scrollToTop2();
  };
  const scrollToTop2 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  {
    /* <video
              ref={videoRef}
              height="100%"
              width="100%"
              autoPlay
              muted
              controls={false}
              onEnded={handleVideoEnd}
            >
              <source src={prod2video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button
              onClick={toggleMute}
              style={{
                position: "absolute",
                top: "10px", // Set the top distance from the top of the video
                right: "10px", // Set the right distance from the right side of the video
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                padding: "10px",
                cursor: "pointer",
              }}
            >
              {isMuted ? "Unmute" : "Mute"}
            </button> */
  }

  return (
    <div
      style={{ position: "relative" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Loading ? (
        <>
          {" "}
          <Carousel
            autoplay
            autoplaySpeed={5000} // every seconds!
            ref={carouselRef}
            arrows={false}
            infinite={true}
            effect={MyWidth <= 1024 ? "none" : "fade"}
          >
            {Loading &&
              AdTopSection?.map((ad, index) => {
                const isDateAfterToday = (dateStr) => {
                  const [day, month, year] = dateStr.split("-").map(Number);
                  const inputDate = new Date(year, month - 1, day);

                  const today = new Date();
                  today.setHours(0, 0, 0, 0); // set to midnight to ignore time differences

                  return inputDate > today;
                };

                // Example:
                const isAfter = isDateAfterToday(ad.dateEnd); // returns true or false

                return (
                  <div key={index}>
                    <img
                      src={
                        i18n.resolvedLanguage === "en"
                          ? ad?.image
                          : i18n.resolvedLanguage === "ar"
                          ? ad?.imageAr
                          : i18n.resolvedLanguage === "he"
                          ? ad?.imageHe
                          : ad?.image
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                        opacity: isAfter ? 1 : 0.5,
                      }}
                      onClick={() => {
                        const number = ad?.linkToTake.split("/").pop();
                        GoTo(number, ad?.linkToTake);
                        //handleDivClick(ad?.linkToTake);
                      }}
                    />
                  </div>
                );
              })}
          </Carousel>
          {MyWidth <= 1024 ? (
            <></>
          ) : (
            <>
              {/* Custom Previous Arrow */}
              {showArrows && (
                <div
                  onClick={prevSlide}
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    left: "10px",
                    // zIndex: 2,
                    cursor: "pointer",
                    //background: "rgba(0, 0, 0, 0.5)",
                    backgroundColor: "white",
                    padding: "10px",
                    //borderRadius: "50%",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <LeftOutlined
                    style={{ fontSize: 20, color: "black", margin: 0 }}
                  />
                </div>
              )}

              {/* Custom Next Arrow */}
              {showArrows && (
                <div
                  onClick={nextSlide}
                  style={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "10px",
                    //zIndex: 2,
                    cursor: "pointer",
                    //background: "rgba(0, 0, 0, 0.5)",
                    backgroundColor: "white",

                    padding: "10px",
                    //borderRadius: "50%",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <RightOutlined
                    style={{ fontSize: 20, color: "black", margin: 0 }}
                  />
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
            paddingTop: 50,
          }}
        >
          <Lottie
            style={{ height: 40, width: 40 }}
            animationData={LottifileLoading}
          />
        </div>
      )}
    </div>
  );
}
